import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import vClickOutside from "v-click-outside";
import "./assets/css/intlTelInput.css";
import "./assets/css/body.css";
import i18n from "./i18n";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueCompositionAPI from "@vue/composition-api";
import Toasted from "vue-toasted";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

Vue.use(Toasted);
Vue.use(VueCompositionAPI);

Vue.use(vClickOutside);
Vue.component("v-select", vSelect);

Vue.toasted.register(
  "default",
  (message) => {
    return message;
  },
  {
    theme: "toasted-primary",
    position: "top-right",
    duration: 5000,
  }
);

Vue.config.productionTip = false;
export const bus = new Vue();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
